<template>
<main class="container-1">

    <div class="center-box">

        <div class="center-aux">
            <p class="title-text">Debe crear una nueva contraseña</p>
        </div>

        <div class="center-input">
            <span>Su contraseña fue generada por un administrador. Para continuar, cree una nueva contraseña.</span>
        </div>
        <br>

        <div class="center-input">
            <label for="new_password">Contraseña nueva</label>
            <div class="password-input-wrap">
                <input id="new_password" v-model="account.new_password" :type="showNewPassword ? 'text' : 'password'" ref="contraseña nueva" autocomplete="new-password"
                name="contraseña nueva" :class="{'error' : errors.has('contraseña nueva') }" v-validate="'required|strong_password'"
                :placeholder="[[errors.has('contraseña nueva') ? errors.first('contraseña nueva') : 'Ingresa la contraseña nueva']]"/>
                <button type="button" class="pw-toggle"
                :aria-label="showNewPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'"
                @click="showNewPassword = !showNewPassword">
                    <font-awesome-icon :icon="showNewPassword ? 'eye-slash' : 'eye'"></font-awesome-icon>
                </button>
            </div>
            <PasswordStrengthMeter :password="account.new_password || ''"></PasswordStrengthMeter>
            <p class="error-label" v-if="errors.has('contraseña nueva')">{{errors.first('contraseña nueva')}}</p>
        </div>

        <div class="center-input">
            <label for="repeat_password">Repita la contraseña nueva</label>
            <div class="password-input-wrap">
                <input id="repeat_password" v-model="repeat_password" :type="showRepeatPassword ? 'text' : 'password'" autocomplete="new-password"
                name="contraseña repetida" :class="{'error' : errors.has('contraseña repetida') }" v-validate="'required|confirmed:contraseña nueva'" data-vv-as="contraseña nueva"
                :placeholder="[[errors.has('contraseña repetida') ? errors.first('contraseña repetida') : 'Ingresa la contraseña repetida']]"/>
                <button type="button" class="pw-toggle"
                :aria-label="showRepeatPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'"
                @click="showRepeatPassword = !showRepeatPassword">
                    <font-awesome-icon :icon="showRepeatPassword ? 'eye-slash' : 'eye'"></font-awesome-icon>
                </button>
            </div>
            <p class="error-label" v-if="errors.has('contraseña repetida')">{{errors.first('contraseña repetida')}}</p>
        </div>

        <div class="center-input">
            <PasswordRequirements :password="account.new_password || ''"></PasswordRequirements>
            <span class="hint">No puede ser igual a la contraseña actual.</span>
        </div>

        <span class="center-input error-label" v-if="message">{{message}}</span>

        <div class="center-aux">
            <LoadSpinner v-if="submitting"></LoadSpinner>
            <button v-else class="btn btn-primary" v-on:click="onClickSubmit()">Guardar y volver a iniciar sesión</button>
        </div>

    </div>

</main>
</template>

<script>
import LoadSpinner from '@/components/LoadSpinner.vue'
import PasswordRequirements from '@/components/PasswordRequirements.vue'
import PasswordStrengthMeter from '@/components/PasswordStrengthMeter.vue'

export default{
    name: 'account-forced-password-change',
    data(){
        return{
            account: {
                new_password: null
            },
            repeat_password: null,
            showNewPassword: false,
            showRepeatPassword: false,
            submitting: false,
            message: null
        }
    },
    components:{
        LoadSpinner,
        PasswordRequirements,
        PasswordStrengthMeter
    },
    computed: {},
    props: [],
    methods:{
        onClickSubmit: function() {
            var that = this;
            this.$validator.validateAll()
            .then(function (response) {
                if(response) {
                    that.changeForcedPassword();
                }
            })
        },
        changeForcedPassword: function() {
            var that = this;
            that.submitting = true;
            that.message = null;
            this.$http.post(this.$store.getters.backendurl + 'api/v1/accounts/password/forced',
            { new_password: this.account.new_password }
            )
            .then(function () {
                //Backend ya invalidó session_cookie — limpiar session_public en cliente
                document.cookie = "session_public=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/;";
                that.$store.commit('setPermissions');
                that.$store.commit('setMustChangePassword', false);
                that.$store.dispatch('toast/show', { message: 'Contraseña actualizada', type: 'info' });
                that.submitting = false;
                that.$router.push('/inicio');
            })
            .catch(function (error) {
                console.log(error)
                that.submitting = false;
                that.message = error.response && error.response.data && error.response.data.message
                    ? error.response.data.message
                    : 'Error al actualizar la contraseña.';
            });
        }
    },
    created () {
        //Este view solo tiene sentido si la sesión tiene el flag; si no, redirigir
        if(!this.$store.state.mustChangePassword) {
            this.$router.push('/inicio')
        }
    }
}
</script>

<style lang="scss" scoped>
// El .error-label global es position:absolute y se encima con el campo siguiente;
// acá se hace fluir en el layout
.error-label {
    position: static;
    margin: 6px 0 0;
    font-size: 12px;
    font-weight: 500;
    line-height: 1.3;
    color: var(--color-danger);
}

.center-box {
    border: solid 2px #004B7A;
    border-radius: 6px;
    min-width: 30%;
    max-width: 540px;
    margin: 2em auto;
    padding: 1em 0;
    background: white;
    box-shadow: 0px 0px 1em black;
}
.title-text {
    font-size: 1.5em;
    font-weight: bold;
    text-align: center;
    margin: 0 1em;
}
.center-aux {
    display: flex;
    justify-content: center;
    margin-top: 1em;
    margin-bottom: 1em;
}
.center-input {
    margin: 0.5em 5%;
    display: block;
}
.hint {
    font-size: 0.9em;
    color: #555;
}
.password-input-wrap {
    position: relative;
}
.password-input-wrap input {
    width: 100%;
    box-sizing: border-box;
    padding-right: 2.5rem;
}
// Edge dibuja su propio ojo nativo y quedarian dos superpuestos
.password-input-wrap input::-ms-reveal,
.password-input-wrap input::-ms-clear {
    display: none;
}
.pw-toggle {
    position: absolute;
    top: 50%;
    right: 0.5rem;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    width: auto;
    margin: 0;
    padding: 0.25rem;
    background: transparent;
    border: none;
    color: var(--color-ghost);
    cursor: pointer;

    &:hover {
        color: var(--color-navy);
    }
}
button {
    margin: 1em 0;
    width: 90%;
}
</style>
